module.exports = __webpack_public_path__ + "assets/cutlery-8c555d.svg";